import {PAGES} from "../../core/consts";

export const BETTING_CONTAINER = {
  SECONDARY_ITEM_SCALE: 0.8,
  ITEMS_GAP: 16,
  FEATURED_LIST_COLLAPSED_COUNT: 3,
  ZOOM_ICON_SIZE: 20,
  SEO_SHARE_IMAGE_FALLBACK:  "https://imagecache.365scores.com/image/upload/v1763547466/WebSite/BettingZone/Wordpress/Social_Share_Image_Fallback.jpg",

  ACTION_TYPES: {
    onActiveMenuButton: 'onActiveMenuButton',
    onActiveAnchorButton: 'onActiveAnchorButton',
    breadcrumbsPopulate: 'breadcrumbsPopulate',
    bettingZonePopulateData: 'bettingZonePopulateData',
    stickyOfferVisibilityChange: 'stickyOfferVisibilityChange',
    globalStickyOfferHandler: 'globalStickyOfferHandler',

    DRAWER_MENU: {
      onNavigationClick: 'onNavigationClick',
      onOpenAndClose: 'onOpenAndClose',
      onRegisterToRouteChange: 'onRegisterToRouteChange'
    }
  },

  SECTION_TYPE: {
    POSTS_SLIDER: 'posts_section',
    BOOKIE_CUBES: 'bookie_cubes',
    ALTERNATE_BOOKIES: 'alternate_bookies',
    OFFER: 'offer',
    FAQ: 'faq',
    TEXT: 'text',
    WIDGET: 'widget',
    DATE_POSTS: 'date-posts',
    COMPARE_TABLE: 'bookies_table'
  },

  API_FILTERS: {
    siteSettings: 'sitesettings',
    homePage: 'homepage',
    bettingSites: 'betting-sites',
    bookies: 'bookies',
    posts: 'posts',
    content: 'content',
    howToBet: 'how-to-bet',
    promotions: 'promotions'
  },

  SITE_HEADER_BUTTONS: {
    mediumBar: 5,
    largeBar: 7,
  },

  ARTICLE_ITEM_WIDTH: {
    desktop: 512,
    mobile: 293,
  },

  MENU_ANCHORS_OFFSET: {
    desktop: 120,
    mobile: 88
  },

  MINIMUM_BOOKIES_CUBES: {
    mobile: 6,
    desktop: 6
  },

  CALCULATOR_ITEM_WIDTH: {
    desktop: 248,
    mobile: 248,
  },

  CALCULATORS_CAROUSEL: {
    CALCULATOR_ITEM_WIDTH: {
      desktop: 248,
      mobile: 248,
    },

    SECONDARY_ITEM_SCALE: 1,
    ITEMS_GAP: 64,
  },

  ICON_PATH: {
    V: "M8.27614 0.942809L2.80474 6.41421L0 3.60948L0.942809 2.66667L2.80474 4.5286L7.33333 0L8.27614 0.942809Z",
    COPY: "M13.3333 1.33325H6.66668C5.93134 1.33325 5.33334 1.93125 5.33334 2.66659V5.33325H2.66668C1.93134 5.33325 1.33334 5.93125 1.33334 6.66659V13.3333C1.33334 14.0686 1.93134 14.6666 2.66668 14.6666H9.33334C10.0687 14.6666 10.6667 14.0686 10.6667 13.3333V10.6666H13.3333C14.0687 10.6666 14.6667 10.0686 14.6667 9.33325V2.66659C14.6667 1.93125 14.0687 1.33325 13.3333 1.33325ZM2.66668 13.3333V6.66659H9.33334L9.33468 13.3333H2.66668ZM13.3333 9.33325H10.6667V6.66659C10.6667 5.93125 10.0687 5.33325 9.33334 5.33325H6.66668V2.66659H13.3333V9.33325Z"
  },

  COMPLIANCE_SECTION_NAME: {
    stickyOffer: 'sticky_offer',
    hero: 'hero',
    specialOffer: 'special_offer',
    tableComparison: 'table_comparison',
    bookiesCubes: 'bookies_cubes',
    alternateBookies: 'alternate_bookies',
    collapseExpands: 'collapse_expands',
    bonusSnippet: 'bonus_snippet',
    bookiePromotions: 'bookie_promotions',
    descriptionOffer: 'description_offer',
    regulatedBookies: 'regulated_bookies',
    article: 'article',
    offers: 'offers'
  },

  MENU_VIEW_TYPE: {
    page: 'PAGE',
    accordion: 'ACCORDION',
  },

  ANALYTICS: {
    ACTION_TYPES: {
      onPageViewHandler: 'onPageViewHandler',
      onBookieReviewClick: 'onBookieReviewClick'
    },

    TRAFFIC_SOURCE: {
      main: '365scores',
      direct: 'direct'
    },

    SOURCE: {
      bookiesCubes: 'bookies-cubes',
      alternateBookies: 'alternative-bookies',
      bookiesTableComparison: 'bookies-table-comparison',
      accaWidget: 'acca-widget',
      stickyOffer: 'sticky-offer',
      specialOffer: 'special-offer',
      bonusSnippet: 'bonus-snippet',
      hero: 'hero',
      descriptionOffer: 'description-offer',
      todayPredictions: 'todays-predictions',
      promotionsSlider: 'promotions-slider',
      promotionsTable: 'promotions-table',
      accountStepper: 'account-stepper',
      ctaOffers: 'cta-offers',
    },
    PAGES_CONTEXT_NAME: {
      [PAGES.BETTING.index]: 'HomePage',
      [PAGES.BETTING.bettingSites]: 'BettingSites',
      [PAGES.BETTING.article]: 'Article',
      [PAGES.BETTING.brandReview]: 'BrandReview',
      [PAGES.BETTING.howToBet]: 'HowToBet',
      betting: 'HomePage',
      ctaArticle: 'cta-article',
    },
    SCREEN_NAME: {
      homePage: 'homepage',
      article: 'article',
      bettingSites: 'bettingsites',
      brandReview: 'brandreview',
      howToBet: 'how-to-bet',
      predictions: 'predictions',
      offers: 'offers',
      competitionPage: 'competitions_page'
    },

    CONTEXT_SOURCE: {
      promotionstable: 'promotionstable',
      bonusSnippet: 'bonussnippet',
      promotionsSlider: 'promotionsslider',
      descriptionOffer: 'welcomeoffer',
      accountStepper: 'accountStepper',
    },
  },

  POSTS_DATA_KEYS: {
    topStories: 'top_stories_section',
    offers: 'offers_widget',
    comparisonTable: 'bookie-compare-block',
    offersCta: 'offers-cta-block',
    widgetSection: 'widget365-block'
  }
};
